import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBChip,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModalFooter,
  MDBRadio,
  MDBRow,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBTypography,
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { formattedNumber } from "./AddRemoveNumbers";
import {
  downloadPortingLOA,
  portingSteps,
  portingStepsForm,
} from "../../../apiclients/streamsapi_bridge";
import { getStreamsProductName } from "../../../apiclients/CommonUtils";
import TabIDConstant from "../../../apiclients/TabIDConstant";

function TFNSignLOA({
  watch,
  handleNext,
  currentStep,
  handleBack,
  telePhoneList,
  setValue,
  portingType,
  setflowStep,
  nextPageclick,
  flowStep,
  handleSubmit,
  uploadedFiles,
  formState,
  signLOAUpload,
  setsignLOAUpload,
  uploadedOldFiles,
  handleSaveDraft,
  orderID,
  setIsloading,
}) {
  const [transferNumbers, settransferNumbers] = useState([]);
  const [allowAreaOfService, setallowAreaOfService] = useState(true);
  // const [uploadFile, setuploadFile] = useState("");
  const streamsProductName = getStreamsProductName();

  useEffect(() => {
    if (allowAreaOfService) {
      setallowAreaOfService(false);
      let updateArr = [...watch("area_of_service")];
      updateArr = updateArr.map((item) => ({
        ...item,
        carrier_name: watch("service_addr.carrier_name"),
        respid: "VNI01",
      }));
      settransferNumbers(updateArr);
    }
  }, [allowAreaOfService]);

  async function handleDownload() {
    try {
      let update = {
        reqid: 105,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        port_type: parseInt(portingType),
        flow_step: parseInt(flowStep),
        orderid: parseInt(orderID),
        enter_num: {
          ddd: watch("enter_num.ddd") ?? "",
        },
        acc_info: {
          // acc_num: watch("acc_info.acc_num") ?? "",
           last_name: watch("acc_info.last_name") ?? "",
           first_name: watch("acc_info.first_name") ?? "",
          company_name: watch("acc_info.company_name") ?? "",
          // bill_tele_num: watch("acc_info.bill_tele_num") ?? "",
          // is_mobile_num: watch("acc_info.is_mobile_num") ?? false,
          // name_listed_on_acc: watch("acc_info.name_listed_on_acc") ?? "",
          porting_num_type: watch("acc_info.porting_num_type") ?? "",
          contact_title: watch("acc_info.contact_title") ?? "",
          authorized_customer_fax: watch("acc_info.authorized_customer_fax") ?? ""
          // acc_type: 1,
        },
        service_addr: {
          zip: watch("service_addr.zip") ?? "",
          city: watch("service_addr.city") ?? "",
          state: watch("service_addr.state") ?? "",
          suite: watch("service_addr.suite") ?? "",
          floor_num: watch("service_addr.floor_num") ?? "",
          street_num: watch("service_addr.street_num") ?? "",
          street_name: watch("service_addr.street_name") ?? "",
          carrier_pin: watch("service_addr.carrier_pin") ?? "",
          carrier_name: watch("service_addr.carrier_name") ?? "",
          carrier_acc_num: watch("service_addr.carrier_acc_num") ?? "",
          // acc_btn: watch("service_addr.acc_btn") ?? "",
        },
        notifs_comments: {
          // email: watch("notifs_comments.email") ?? "",
          // comments: watch("notifs_comments.comments") ?? "",
          contact_ph_num: watch("notifs_comments.contact_ph_num") ?? ""
          // send_email_to_admin:
          //   watch("notifs_comments.send_email_to_admin") ?? true,
        },
        area_of_service: watch("area_of_service") ?? [],
        // checklist: {
        //   check_ans_one: watch("checklist.check_ans_one") ?? true,
        //   check_ans_five: watch("checklist.check_ans_five") ?? true,
        //   check_ans_four: watch("checklist.check_ans_four") ?? true,
        // },
        number: telePhoneList ?? [],
        notifs_comments : {
          contact_ph_num: watch("notifs_comments.contact_ph_num") ?? "",
        }
        // assign: watch("assign") ?? [],
      };

      console.log("final request :::::::: " + JSON.stringify(update));
      setIsloading(true);
      let apiResponse = await downloadPortingLOA(update);
      setIsloading(false);
      let filename = "";
      if (apiResponse.status == 200) {
        const contentDisposition = apiResponse.headers.get(
          "Content-Disposition"
        );
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }
        const fileUrl = URL.createObjectURL(await apiResponse.blob());
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        // setInternalError(true);
      }
    } catch (error) {
      console.log("Error ::::::::: " + error);
    }
  }

  const { dirtyFields, isDirty, errors } = formState;

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append(
        "siteid",
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      formData.append("reqid", 95);
      formData.append("port_type", parseInt(portingType));
      formData.append("flow_step", parseInt(flowStep));
      formData.append("confirm_flag", true);
      formData.append("status", 1);
      formData.append("orderid", parseInt(orderID));

      for (const field of Object.keys(dirtyFields)) {
        let modifiedData = {};
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            for (const subfield of Object.keys(dirtyFields[field])) {
              if (data[field].hasOwnProperty(subfield)) {
                modifiedData[subfield] = data[field][subfield];
              }
            }
            if (field === "acc_info") {
              modifiedData.porting_num_type = data[field]["porting_num_type"];
            }
            if (field === "notifs_comments") {
              modifiedData.send_email_to_admin =
                data[field]["send_email_to_admin"];
            }

            if (field !== "checklist") {
              formData.append(field, JSON.stringify(modifiedData));
            }
          } else {
            modifiedData = [...data[field]];
            formData.append(field, JSON.stringify(modifiedData));
          }
        }
      }

      formData.append("checklist", JSON.stringify(data.checklist));
      uploadedFiles.forEach((file) => {
        formData.append("upload_latest_bill", file, file.name);
      });
      // if (uploadedOldFiles && uploadedOldFiles.length > 0) {
      //   uploadedOldFiles.forEach((file) => {
      //     formData.append("old_cob_files", file, file.name);
      //   });
      // }
      if (signLOAUpload && signLOAUpload.name) {
        const blob = new Blob([signLOAUpload], { type: "application/pdf" });
        formData.append("sign_loa", blob, signLOAUpload.name);
      }

      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}: ${value}`);
      // }
      setIsloading(true);
      let saverep = await portingStepsForm(formData, TabIDConstant.TN_TFN_PORT_BTN_SUBLINK);
      setIsloading(false);
      console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log("response of next:::" + JSON.stringify(saverepeMsg));
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        // setorderID(saverepeMsg.order_id);
        setflowStep(parseInt(flowStep) + 1);
        nextPageclick();
      } else {
      }
    } catch (error) {
      console.log(`Error: ${error}`);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB
    if (file.type !== "application/pdf") {
      alert(`Upload only PDF File.`);
      return;
    }
    if (fileSizeInMB <= 25) {
      setsignLOAUpload(file);
      // Check if file size is within limit
    } else {
      alert(`File '${file.name}' exceeds the maximum file size of 25 MB.`);
    }
  };

  return (
    <>

      <MDBContainer className="my-3 formA-wrap">
        {/* Local styles (keeps it self-contained) */}
        <style>{css}</style>

        <div className="tfnLoa overflowAuto position-relative">
          <MDBCard className="formA-card">
            <MDBCardBody className="p-0 position-relative">
              {/* Top bar */}
              <div className="px-4 pt-4 pb-3 d-flex align-items-center justify-content-between">
                <div>
                  <div className="formA-topTitle">ANI NETWORKS CARRIER CHANGE REQUEST</div>
                  <div className="formA-formTitle">FORM A</div>
                </div>

            <MDBBtn
              onClick={(e) => {
                e.preventDefault();
                handleDownload();
              }}
            >
              <MDBIcon fas icon="download" className="me-2" /> Download
            </MDBBtn>
          </div>

              {/* Meta */}
              <div className="formA-section px-4 pb-4">
                <table className="formA-table">
                  <tbody>
                    <tr>
                      <td className="formA-labelCell">  Today’s Date: {`${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}-${new Date().getFullYear()}`}
                      </td> 
                      <td className="formA-labelCell formA-smallCol" align="left" style={{width: "250px !important;"}}>ID: 100764</td> 
                    </tr>
                    <tr>
                      <td className="formA-labelCell" colSpan={4}>
                        <div className="d-flex flex-column gap-2">
                          <div className="formA-label">Toll Free Number(s):</div>
                          <span className="formA-value d-flex flex-wrap noHoverBg">
                            {telePhoneList && telePhoneList.length
                              ? telePhoneList.map((n, index) => (
                                  <MDBChip key={index} className="noHoverBg">
                                    {formattedNumber(n)} 
                                  </MDBChip>
                                ))
                              : ""}
                          </span>
                </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Carrier block */}
              <div className="formA-section px-4 pb-4">
                <table className="formA-table">
                  <tbody>
                  
                    <tr>
                       <td className="formA-labelCell">

                                              <div className="formA-twoColGrid">
                          <div className="formA-row" style={{gap:"0px"}}>
                            <div className="formA-rowLabel"><span className="formA-label">NEW CARRIER: <span className="fw-500">GDG35</span></span></div>
                            <div className="formA-rowColon"></div>
                            <div className="formA-rowLabel">Current Carrier: <span className="fw-500">{watch("service_addr.carrier_name") || ""}</span></div>
            </div>

                </div>
                       </td>
                    </tr>

                    <tr>
                      <td className="formA-labelCell" colSpan={2}>
                        <div className="formA-twoColGrid">
                          <div className="formA-row">
                            <div className="formA-rowLabel">New Carrier Contact</div>
                            <div className="formA-rowColon">:</div>
                            <div className="formA-rowValue">Jeannie DiPuccio</div>
                  </div>
                          <div className="formA-row">
                            <div className="formA-rowLabel">New Carrier Telephone #</div>
                            <div className="formA-rowColon">:</div>
                            <div className="formA-rowValue">1-702-547-8786</div>
                </div>
                          <div className="formA-row">
                            <div className="formA-rowLabel">New Carrier Fax #</div>
                            <div className="formA-rowColon">:</div>
                            <div className="formA-rowValue">1-702-547-8518</div>
                  </div>
                </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>

              {/* Customer Information */}
              <div className="px-4 pt-1">
                <h5 className="formA-heading mb-3">Customer Information</h5>
                  </div>

              <div className="formA-section px-4 pb-4">
                <table className="formA-table">
                  <tbody>
                    <tr>
                      <td className="formA-labelCell" colSpan={4}>
                        <div className="formA-twoColGrid">



                          <div className="formA-row">
                            <div className="formA-rowLabel">Company Name</div>
                            <div className="formA-rowColon">:</div>
                            <div className="formA-rowValue">{watch("acc_info.company_name") || ""}</div>
                </div>
                          <div className="formA-row">
                            <div className="formA-rowLabel">Company Address</div>
                            <div className="formA-rowColon">:</div>
                            <div className="formA-rowValue">
                              {[
                                watch("service_addr.floor_num") ? `${watch("service_addr.floor_num")}` : "",
                                watch("service_addr.suite") ? `${watch("service_addr.suite")}` : "",
                                watch("service_addr.street_num") ? `${watch("service_addr.street_num")}` : "",
                                watch("service_addr.street_name") ? `${watch("service_addr.street_name")}` : "",
                                watch("service_addr.city") ? `${watch("service_addr.city")}` : "",
                                watch("service_addr.state") ? `${watch("service_addr.state")}` : "",
                                watch("service_addr.zip") ? `${watch("service_addr.zip")}` : "",
                              ]
                                .filter(Boolean)
                                .join(", ")}
                  </div>
                </div>
                          <div className="formA-row">
                            <div className="formA-rowLabel">Authorized Customer Contact</div>
                            <div className="formA-rowColon">:</div>
                            <div className="formA-rowValue">{watch("acc_info.first_name") || ""} {watch("acc_info.last_name") || ""}</div>
                </div>
                          <div className="formA-row">
                            <div className="formA-rowLabel">Contact Title </div>
                            <div className="formA-rowColon">:</div>
                            <div className="formA-rowValue">{watch("acc_info.contact_title") || ""}</div>
                  </div>
                          <div className="formA-row">
                            <div className="formA-rowLabel">Authorized Customer Tel #</div>
                            <div className="formA-rowColon">:</div>
                            <div className="formA-rowValue">{watch("notifs_comments.contact_ph_num") || ""}</div>
                </div>
                          <div className="formA-row">
                            <div className="formA-rowLabel">Authorized Customer Fax #</div>
                            <div className="formA-rowColon">:</div>
                            <div className="formA-rowValue">{watch("acc_info.authorized_customer_fax") || ""}</div>
                          </div>
                          <div className="formA-row">
                            <div className="formA-rowLabel">Desired Due Date</div>
                            <div className="formA-rowColon">:</div>
                            <div className="formA-rowValue">{watch("enter_num.ddd")?.replaceAll("/", "-") || ""}</div>
                  </div>
                </div>
                      </td>
                    </tr>
                  </tbody>
                </table>


                <div className="formA-topTitle mt-3">*ANI Networks is to become the New Carrier on the above listed Toll Free numbers(s)
                </div>
                <u className="formA-topTitle">
                  (Including any numbers contained on any continuation sheet(s))*
                </u>

                <div className="d-flex align-items-center justify-content-between mt-5 pt-5">

                  <td>Authorized Customer Signature</td>
                  <td width={"200px"}>
                    Date:
                  </td>
                </div>
            </div>

            </MDBCardBody>
          </MDBCard>
          {/* Sticky note */}
          <div className="position-sticky bottom-0 bg-white card shadow-0 ">
            <p className="text-danger mb-0 px-4">
              <b>Note:</b> Please download LOA and read all the details carefully. Sign the downloaded LOA and upload.
            </p>
          </div>
        </div>
      </MDBContainer>







      <MDBModalFooter className="d-flex justify-content-between">
        <div className="d-flex align-items-center">
          {signLOAUpload && (
            <>
              <MDBBtn
                color="secondary"
                className="text-normal-case"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(handleSaveDraft)();
                }}
              >
                Save to Draft
              </MDBBtn>
            </>
          )}
          <span id="draftsuccess"></span>
          <MDBBtn
            className="ms-2"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("fileInput").click();
            }}
          >
            <MDBIcon fas icon="upload" className="me-2" /> Upload
          </MDBBtn>
          <input
            id="fileInput"
            type="file"
            accept=".pdf"
            style={{ display: "none" }}
            onChange={handleFileUpload}
          />
          <div className="ps-4">
            {signLOAUpload?.name || signLOAUpload?.file_name}
          </div>
        </div>

        <div className="text-end">
          {/* <MDBBtn color="secondary" className="me-2">
            Back
          </MDBBtn> */}
          {signLOAUpload && (
            <MDBBtn
              onClick={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit)();
              }}
            >
              Submit
            </MDBBtn>
          )}
        </div>
      </MDBModalFooter>
    </>
  );
}

export default TFNSignLOA;




const css = `
.formA-wrap { max-width: 1100px; }
.formA-card {   overflow: hidden; }
.formA-topTitle { font-weight: 700; letter-spacing: 0.5px; font-size: 14px; }
.formA-formTitle { font-weight: 800; font-size: 20px; margin-top: 4px; } 
.formA-table { width: 100%; border-collapse: collapse; border: 1px solid #d9d9d9; }
.formA-table td { border-bottom: 1px solid #d9d9d9; padding: 14px 12px; vertical-align: top;  }
.formA-labelCell { font-weight: 700; }
.formA-valueCell { font-weight: 500; }
.formA-smallCol { width: 150px !important; white-space: nowrap; }
.formA-label { font-weight: 700; }
.formA-value { font-weight: 500; margin-top: 2px; }
.formA-colon { font-weight: 700; }
.formA-heading { font-weight: 800; margin-top: 6px; }
.formA-twoColGrid { display: grid; gap: 12px; }
.formA-row { display: grid; grid-template-columns: 280px 18px 1fr; gap: 8px; align-items: start; }
.formA-rowLabel { font-weight: 700; }
.formA-rowColon { font-weight: 700; text-align: center; }
.formA-rowValue { font-weight: 500; word-break: break-word; }
.formA-signBox { max-width: 520px; }

/* Your existing wrapper class names - safe defaults */
.tfnLoa { width: 100%; }
.overflowAuto { overflow: auto; }

/* Make the “print-like” look nice on mobile */
@media (max-width: 768px) {
  .formA-row { grid-template-columns: 1fr; }
  .formA-rowColon { display: none; }
  .formA-smallCol { width: auto; white-space: normal; }
}

.tfnLoa table tr:hover{
background: transparent !important;
}
`;

